import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { theme } from '@shared/components';

export const QBS_LEVEL_TAG_COLOR_BY_CATEGORY = {
  [QBankStructureLevelCategory.Course]: 'hsla(37, 96%, 59%, 1)',
  [QBankStructureLevelCategory.Part]: 'hsla(0, 0%, 9%, 1)',
  [QBankStructureLevelCategory.Subject]: 'hsla(26, 95%, 44%, 1)',
  [QBankStructureLevelCategory.Group]: 'hsla(32, 92%, 50%, 1)',
  [QBankStructureLevelCategory.Chapter]: 'hsla(37, 96%, 59%, 1)',
  [QBankStructureLevelCategory.Topic]: 'hsla(40, 97%, 65%, 1)',
  [QBankStructureLevelCategory.SubTopic]: 'hsla(42, 97%, 77%, 1)',
};

export const QBS_LEVEL_TAG_TEXT_COLOR_BY_CATEGORY = {
  [QBankStructureLevelCategory.Course]: theme.palette.text.primary,
  [QBankStructureLevelCategory.Part]: theme.palette.common.white,
  [QBankStructureLevelCategory.Subject]: theme.palette.common.white,
  [QBankStructureLevelCategory.Group]: theme.palette.common.white,
  [QBankStructureLevelCategory.Chapter]: theme.palette.text.primary,
  [QBankStructureLevelCategory.Topic]: theme.palette.text.primary,
  [QBankStructureLevelCategory.SubTopic]: theme.palette.text.primary,
};
